import React from "react";
import { Link } from "react-router-dom";
import Icon from "../Icon";
import { ClubLogo, Pill } from "../primitives";
import { isEventInOTPWindow, toDate } from "../../lib/format";
import { dayLabel, dayOfMonth, monthShort, timeLabel } from "../../../../utils/eventDateParts";
import { hueFor, photo } from "../../lib/gradients";

/**
 * Mockup `evCard` (club Events tab, Profile events, Events feed).
 * - `to`: when set, the title links to the event page (state carries the event so the
 *   details page paints at once). The RSVP control stays a sibling, never nested in the link.
 * - `hideRsvp`: no RSVP control (Profile "My events", mobile ProfileEventsSection parity).
 * - `testId`: row id on the title link; the RSVP control is `${testId}.rsvp` / `${testId}.cancelRsvp`.
 */
export default function ClubEventCard({ event, club, going, checkedIn, busy, onToggle, to, hideRsvp = false, testId = `eventRow.${event.id}` }) {
  const at = toDate(event.start_date);
  const live = isEventInOTPWindow(event);
  const bg = event.image_url
    ? `url("${event.image_url}") center / cover`
    : photo(hueFor(event.id));
  return (
    <div className="card evcard">
      <div className="poster" style={{ background: bg }}>
        {at && <span className="stub"><small>{monthShort(at)}</small><b>{dayOfMonth(at)}</b></span>}
        <ClubLogo club={club} size={26} />
      </div>
      <div className="grow col" style={{ gap: 5, padding: "2px 0", minWidth: 0 }}>
        <div className="row" style={{ gap: 6 }}>
          {live && <Pill tone="live">LIVE NOW</Pill>}
          {event.is_public === false && <Pill tone="purple" icon="lock">Members</Pill>}
          <span className="meta ellip">{club.name}</span>
        </div>
        <h3>{to ? <Link to={to} state={{ event }} style={{ color: "inherit" }} data-testid={testId}>{event.title}</Link> : event.title}</h3>
        {at && <div className="inforow"><Icon name="clock" size={14} />{dayLabel(at)} · {timeLabel(at)}</div>}
        {event.location ? <div className="inforow"><Icon name="pin" size={14} /><span className="ellip">{event.location}</span></div> : null}
      </div>
      <div className="col" style={{ alignItems: "flex-end", justifyContent: "space-between" }}>
        {hideRsvp ? <span /> : checkedIn ? (
          <Pill tone="green" icon="check">Checked in</Pill>
        ) : going ? (
          <button type="button" className="pill p-green" style={{ cursor: "pointer" }} disabled={busy} onClick={() => onToggle(event)} data-testid={`${testId}.cancelRsvp`} title="Remove RSVP" aria-label="You're in. Remove RSVP">
            <Icon name="check" size={12} />You&apos;re in
          </button>
        ) : (
          <button type="button" className="btn pri xs" disabled={busy} onClick={() => onToggle(event)} data-testid={`${testId}.rsvp`}>RSVP</button>
        )}
        <span className="meta tnum">{event.attendee_count || 0} going</span>
      </div>
    </div>
  );
}
